module.exports = __webpack_public_path__ + "img/fire-smoke.efe3be41.png";